module.exports = __webpack_public_path__ + "static/img/ent-detail-76.b47dfdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-76.jpg
// module id = 38zo
// module chunks = 51